export default "__VITE_ASSET__C$vXwVoM__"